<template>
	<div class="toast" v-if="flag">
		<p>{{content}}</p>
	</div>
</template>

<script>
	export default{
		props:{
			content:{
				required:true,
				type:String
			}
		},
		data(){
			return{
				flag:false,
				
			}
		},
		watch:{
			flag(){
				if(this.flag){
					setTimeout(()=>{
						this.flag = false;
					},1500);
				}
			}
		}
	}
</script>

<style scoped>
	.toast{
		position: fixed;
		top: 30%;
		left: 30%;
		width: 200px;
		padding: 10px 20px;
		background-color: #007AFF;
		border-radius: 5px;
		opacity: 0.9;
	}
	.toast p{
		line-height: 20px;
		color: #fff;
		word-break: break-all;
		text-align: center;
	}
</style>
